import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const selectStylingStore = (state) => state.styling;

const makeSelectStyling = () => createSelector(
  selectStylingStore,
  ({ stylingSettings }) => stylingSettings,
);

const makeSelectMainStyling = () => createSelector(
  selectStylingStore,
  ({ mainStylingSettings }) => mainStylingSettings,
);

const makeSelectStylingConfigs = () => createSelector(
  selectStylingStore,
  ({ stylingConfigSettings }) => stylingConfigSettings,
);

const makeSelectSplashScreenSettings = () => createSelector(
  selectStylingStore,
  ({ splashScreenSettings }) => splashScreenSettings,
);

const makeSelectSplashScreenConfigs = () => createSelector(
  selectStylingStore,
  ({ splashScreenConfigSettings }) => splashScreenConfigSettings,
);

export {
  selectStylingStore,
  makeSelectStyling,
  makeSelectMainStyling,
  makeSelectStylingConfigs,
  makeSelectSplashScreenConfigs,
  makeSelectSplashScreenSettings,
};
